import { useParams } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useOwnLiveSession } from './SocketContext';
import LiveOverview from './components/live/LiveOverview';
import LiveSessionView from './components/live/LiveSessionView';

/**
 * /live            — providers: grid of every live session they may see (LiveSessionTile);
 *                    players: their own live session, or the waiting state.
 * /live/:sessionId — one live session's dashboard (the relay checks access on join).
 */
export default function LiveSessionPage() {
    const { sessionId } = useParams();
    const { user } = useAuth();
    const own = useOwnLiveSession();

    if (sessionId) return <LiveSessionView key={sessionId} sessionId={sessionId} />;
    if (user?.role === 'player' && own) return <LiveSessionView key={own.sessionId} sessionId={own.sessionId} />;
    return <LiveOverview />;
}
